import React, { useEffect, useMemo, useRef, useState } from 'react'
import { DataCollectionModal, DataCollectionState } from '../add-new-data-collection/new-data-collection-state';
import ColumnSelectionController from '../column-selection/column-selection';
import { isNullOrEmpty } from '../../../services/data-source-validation';
import { useLocation, useNavigate } from 'react-router-dom';
import * as collectionService from '../../../services/data-collection.service';
import * as connectionService from '../../../services/data-source.service';
import { toast } from 'react-toastify';
import { AppEnum } from '../../../constants/app-enum';
import { authorizeAgain, getToken } from '../../../services/authorize-again-service';
import { sortMethod } from '../../../shared/code-challanges/code-challanges';
import { getTemplateCollectionParameters, updateParameterValues } from '../utils/template-collection-parameter';
import { findDisplayFormat } from '../add-new-data-collection/add-new-data-collection';
import { updateDisplayOrder } from '../../../components/common/ag-grid/grid-data-helper';
import { defaultJavaScriptEditorValue } from '../column-selection/cloud-data-script/cloud-data-script-controller';

export function filterCollectionParams(collectionParameters){
    const pattern = new RegExp(`(${AppEnum.ReservedKeywords.filter}|${AppEnum.ReservedKeywords.sort}|${AppEnum.ReservedKeywords.limit})`, 'i');
    
    return collectionParameters.filter(
        obj => !pattern.test(obj.parameterName)
    );
}

export function checkOtherParams(collectionParameters){
    return collectionParameters?.some(
        param => (param.parameterTypeCD.toLowerCase() !== AppEnum.ParameterType.FixedHidden.toLocaleLowerCase() && 
            param.parameterName.toLowerCase() !== AppEnum.ReservedKeywords.filter.toLowerCase() &&
            param.parameterName.toLowerCase() !== AppEnum.ReservedKeywords.sort.toLowerCase() &&
            param.parameterName.toLowerCase() !== AppEnum.ReservedKeywords.limit.toLowerCase()
    ));
}

export default function DataVisualizerController(props) {
    const {isForDataCollections, closeWindowOnPopupClose, collectionUId, setShowDataVisualizer, showDataVisualizer, excelDataState, setExcelDataState} = props;
    const location = useLocation();
    const navigate = useNavigate();
    const [pluginParameterState, setPluginParameterState] = useState(excelDataState ?? {});
    const [queryState, setQueryState] = useState()
    const [state, setState] = useState(new DataCollectionState());
    const [selectedConnection, setSelectedConnection] = useState([]);
    const [isCloudLoading, setIsCloudLoading] = useState(false);
    const [prevCloudFilterationData, setPrevCloudFilterationData] = useState({
        prevFilterData: [],
        prevSortData: [],
        prevLimitData: null,
        templateCollectionId: null,
        childTemplateInheritedCollectionId: null
    });
    const [isCloudFilterationData, setIsCloudFilterationData] = useState(false);
    const [isSearchOptionsAvailable, setIsSearchOptionsAvailable] = useState(false);
    const [searchOptionsParameters, setSearchOptionsParameters] = useState([]);
    const [maunalColumns,setManualColumns] = useState([]);
    const [columnOverriden,setColumnOverriden] = useState(false);
    const [prevCloudTransformationScripts, setPrevCloudTransformationScripts] = useState({ //state to manage object change in DV
        transformationScript: null,
        stylingScript: null,
        transformationScriptId: null,
        stylingScriptId: null,
        templateCollectionId: null
    });
    const [ collectionType, setCollectionType] = useState(AppEnum.CollectionType.FromScratch);
    const previousChildCompanyUID = useRef(null);

    const collectionTypeTemplate = useMemo(()=>{ 
        return collectionType === AppEnum.CollectionType.FromChildTemplate
    },[collectionType])

    useEffect(() => {
        if(!showDataVisualizer){
            const urlParams = new URLSearchParams(window.location.search);
            storeQueryDetails(urlParams);
            setIsCloudLoading(true);
        }
        else{            
            setQueryState(
                {
                    CollectionUId: collectionUId,
                    CloseWindowOnPopupClose: closeWindowOnPopupClose,
                    isForDataCollections: isForDataCollections,
                }
            )
        }
    }, [])

    useEffect(() => {
        if (state?.connectionUId && queryState?.CollectionUId) {
            getCurrentConnectionDetails(state.connectionUId);
            getDisplayFormatList();
        }
    }, [state?.connectionUId, queryState?.CollectionUId])

    useEffect(() => {
        if (state?.collectionParameters.length > 0 && prevCloudFilterationData?.templateCollectionId === null && queryState?.CollectionUId && !collectionTypeTemplate) {
            const filterParameter = state?.collectionParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.filter);
            const sortParameter = state?.collectionParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.sort);
            const limitParameter = state?.collectionParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.limit);
            if (filterParameter && filterParameter?.length > 0) {
                const filter = JSON.parse(filterParameter[0].defaultValue);
                setPrevCloudFilterationData(prevState => ({
                    ...prevState,
                    prevFilterData: filter,
                    templateCollectionId: state?.templateCollectionId,
                    childTemplateInheritedCollectionId: state?.childTemplateInheritedCollectionId
                }));
            }
            if (sortParameter && sortParameter?.length > 0) {
                const sort = JSON.parse(sortParameter[0].defaultValue);
                setPrevCloudFilterationData(prevState => ({
                    ...prevState,
                    prevSortData: sort,
                    templateCollectionId: state?.templateCollectionId,
                    childTemplateInheritedCollectionId: state?.childTemplateInheritedCollectionId
                }));
            }
            if (limitParameter && limitParameter?.length > 0) {
                const limit = JSON.parse(limitParameter[0].defaultValue);
                setPrevCloudFilterationData(prevState => ({
                    ...prevState,
                    prevLimitData: limit,
                    templateCollectionId: state?.templateCollectionId,
                    childTemplateInheritedCollectionId: state?.childTemplateInheritedCollectionId
                }));
            }
        }
    }, [state?.collectionParameters])

    useEffect(() => {
        if ((selectedConnection && !state?.templateCollectionId) || queryState?.CollectionUId) {
            getCollectionObjectByType();
            getCollectionObjectByType(AppEnum.CollectionType.FromChildTemplate);
        }
    }, [selectedConnection]);

    useEffect(() => {
        if (state?.cloudCollectionObjects.length > 0 && state?.templateCollectionId){
            let object = state?.cloudCollectionObjects?.find(i => i.templateCollectionId == state?.templateCollectionId);
            if (object){
                getTemplateCollectionParameters(object?.templateCollectionUId, setState, setIsSearchOptionsAvailable, setSearchOptionsParameters, setManualColumns, setColumnOverriden, queryState.CollectionUId, state, pluginParameterState);
            }
        }
    }, [state?.cloudCollectionObjects, state?.templateCollectionId])  
    
    useEffect(() => {
        if (prevCloudTransformationScripts?.templateCollectionId === null && collectionUId) {
            setPrevCloudTransformationScripts(prevState => ({
                ...prevState,
                transformationScript: state?.cloudDataTransformationScript,
                stylingScript: state?.dataStylingScript,
                transformationScriptId: state?.dataStylingScriptId,
                stylingScriptId:  state?.dataTransformationScriptId,
                templateCollectionId: state?.templateCollectionId
            }));
        }
    }, [state?.cloudDataTransformationScript, state?.dataStylingScript, state?.dataStylingScriptId, state?.dataTransformationScriptId])

    useEffect(() => {
        const fetchCollectionData = async () => {
            const { cloudCollectionObjects, templateCollectionId, childCompanyCollectionUId, childCollectionUId } = state || {};
            
            if (!cloudCollectionObjects?.length || !templateCollectionId) return;

            const currentUID = childCompanyCollectionUId || childCollectionUId;

            if (collectionTypeTemplate && childCompanyCollectionUId && previousChildCompanyUID.current !== currentUID) {
                setIsCloudFilterationData(false);
                await getCollectionDetails(childCompanyCollectionUId);
                previousChildCompanyUID.current = currentUID;
            }
            else if(!collectionTypeTemplate){
                previousChildCompanyUID.current = null;

                setState(prevState => ({
                    ...prevState, cloudDataTransformationScript: defaultJavaScriptEditorValue, dataStylingScript: defaultJavaScriptEditorValue,
                    childCompanyCollectionUId: null, childTemplateInheritedCollectionId: null, collId: null, collectionParameters: [],
                }));
                const object = cloudCollectionObjects.find( i => i.templateCollectionId === templateCollectionId);

                if (object) {
                    getTemplateCollectionParameters(object.templateCollectionUId, setState, setIsSearchOptionsAvailable,
                        setSearchOptionsParameters, setManualColumns, setColumnOverriden, collectionUId, state);
                    }
                }
            };        
        fetchCollectionData();
    }, [state?.childCompanyCollectionUId, state?.childCollectionUId])

    const getCollectionDetails = async (collectionUId) => {
        let uId = collectionUId || queryState.CollectionUId;
        collectionService.getCollectionDetails(uId)
            .then((response) => {
                if (response?.data) {
                    let prevCollection = response?.data;
                    if (prevCollection) {
                        if(collectionTypeTemplate && prevCollection.collectionParameters?.length > 0){
                            prevCollection.collectionParameters?.forEach(obj => {
                                obj.collectionId = state?.id ?? prevCollection.id;
                                delete obj.collectionUId;
                                delete obj.uId;
                            });
                        }
    
                        setState((prevState) => {

                            return {
                                ...prevState,
                                uId: prevCollection.uId,
                                childTemplateInheritedCollectionId : prevCollection.childTemplateInheritedCollectionId || state?.childTemplateCollectionId,
                                sysCollectionTypeId: prevCollection.sysCollectionTypeId,
                                sysConnectionTypeId: prevCollection.sysConnectionTypeId,
                                sysCollectionSubTypeId: prevCollection.sysCollectionSubTypeId,
                                childGroupName: prevCollection.childGroupName,
                                groupName: (queryState.CollectionUId && collectionTypeTemplate) ? (state?.groupName || prevCollection.groupName) : prevCollection.groupName,
                                sourceName: prevCollection.sourceName,
                                sourceNamePart2: prevCollection.sourceNamePart2,
                                sourceNamePart4: prevCollection.sourceNamePart4,
                                isCollectionAsDataSource: prevCollection.isCollectionAsDataSource,
                                hasPrintableCollection: prevCollection.hasPrintableCollection,
                                collectionColumns: prevCollection.collectionColumns,
                                collectionParameters: prevCollection.collectionParameters,
                                collectionFilterColumns: prevCollection.collectionFilterColumns,
                                name: (queryState.CollectionUId && collectionTypeTemplate) ? (state?.name || prevCollection.name) : prevCollection.name,
                                connectionUId: collectionTypeTemplate ? selectedConnection?.uId : prevCollection.connectionUId,
                                categoryUId: prevCollection.categoryUId,
                                restSendAsCD: prevCollection.restSendAsCD,
                                restDataTransformationScript: prevCollection.restDataTransformationScript,
                                restBody: prevCollection.restBody,
                                restRequestMethod: prevCollection.restRequestMethod,
                                prevCollection: prevCollection,
                                basicInfoError: null,
                                templateCollectionId: prevCollection.templateCollectionId,
                                isFilterSupported: prevCollection.isFilterSupported,
                                isSortSupported: prevCollection.isSortSupported,
                                isPagingSupported: prevCollection.isPagingSupported,
                                areAllFieldsFilterable: prevCollection.areAllFieldsFilterable,
                                areAllFieldsSortable: prevCollection.areAllFieldsSortable,
                                columnApiEndpoint: prevCollection.columnApiEndpoint,
                                variableId: prevCollection.variableId,
                                returnRawData: prevCollection.returnRawData,
                                savedParameterValue: prevCollection.savedParameterValue,
                                useTemplateConnection: prevCollection.useTemplateConnection,
                                cloudDataTransformationScript: prevCollection.cloudDataTransformationScript,
                                dataStylingScript : prevCollection.dataStylingScript,
                                dataStylingScriptId : prevCollection.dataStylingScriptId,
                                dataTransformationScriptId : prevCollection.dataTransformationScriptId,
                                flattenLikeSql: prevCollection.flattenLikeSql || false,
                                excludedProperties: prevCollection.excludedProperties || "",
                                gptPrompt: prevCollection.gptPrompt || "",
                            }
                        })
                        if (prevCollection.isTemplateCollection && prevCollection.isInheritCollection) {
                            setState((prevState) => { return { ...prevState, uId: null } });
                        }
                        if (prevCollection?.collectionParameters?.length > 0){
                            const hasOtherParams = checkOtherParams(prevCollection?.collectionParameters);
                              if (hasOtherParams){
                                prevCollection["collectionParameters"] = filterCollectionParams(prevCollection?.collectionParameters)
                                let updatedParams = updateParameterValues(prevCollection.collectionParameters, prevCollection?.savedParameterValue, excelDataState);
                                setIsSearchOptionsAvailable(true);
                                setSearchOptionsParameters(updatedParams);
                              }
                              else{
                                setIsSearchOptionsAvailable(false);
                                setSearchOptionsParameters([]);
                              }
                        }
                        else{
                            setIsSearchOptionsAvailable(false);
                            setSearchOptionsParameters([]);
                        }
                        getCollectionTypeList(prevCollection.sysCollectionTypeId);
                    }
                }
                else if (response?.hasError)
                    setState((prevState) => { return { ...prevState, basicInfoError: response.errorMessage } });

                return true;
            })
    } 
    
    const handleQueryDetails = (urlParams) => {
        const isMergeCollectionFromExcel = urlParams.get('isMergeCollectionFromExcel');
        const isGoogleDriveFromExcel = urlParams.get('isGoogleDriveFromExcel');

        const isMergeCollectionFromExcelResult = isMergeCollectionFromExcel?.toLowerCase() == "true" ? true : false;
        const isGoogleDriveFromExcelResult = isGoogleDriveFromExcel?.toLowerCase() == "true" ? true : false;

        if (isMergeCollectionFromExcelResult || isGoogleDriveFromExcelResult) {
            const collectionUId = urlParams.get('collectionUId');
            const data = urlParams.get('data');
            const parameters = urlParams.get('Parameters');
            const isEditMode = urlParams.get('isEditMode');
            const isNativeVisualizer = urlParams.get('isNativeVisualizer');
    
            setPluginParameterState(
                {
                    collectionUId: collectionUId,
                    isMergeCollectionFromExcel: isMergeCollectionFromExcelResult,
                    data: data,
                    parameters: parameters,
                    isEditMode: isEditMode?.toLowerCase() == "true" ? true : false,

                    isGoogleDriveFromExcel: isGoogleDriveFromExcelResult,
                    isNativeVisualizer: isNativeVisualizer?.toLowerCase() == "true" ? true : false,
                    isCommandFromExcel: (isMergeCollectionFromExcelResult || isGoogleDriveFromExcelResult),
                }
            )
        }
    }
    const storeQueryDetails = (urlParams) => {
        handleQueryDetails(urlParams)
        const closeWindowOnPopupClose = urlParams.get('closeWindowOnPopupClose');
        const collectionUId = urlParams.get('collectionUId');
        const accessToken = urlParams.get('AccessToken');
        const refreshToken = urlParams.get('RefreshToken');
        const aSTenantUId = urlParams.get('ASTenantUId');
        const isForDataCollections = urlParams.get('isForDataCollections');

        setQueryState(
            {
                CollectionUId: collectionUId,
                CloseWindowOnPopupClose: closeWindowOnPopupClose?.toLowerCase() == "true" ? true : false,
                isForDataCollections: isForDataCollections
            }
        )

        if ((accessToken != null && refreshToken != null && aSTenantUId != null)) {

            localStorage.setItem("refresh_token", refreshToken);
            localStorage.setItem("token", accessToken);
            localStorage.setItem("ASTenantId", aSTenantUId);

            urlParams.delete('closeWindowOnPopupClose');
            urlParams.delete('AccessToken');
            urlParams.delete('RefreshToken');
            urlParams.delete('ASTenantUId');
            urlParams.delete('isForDataCollections');

            urlParams.delete('isMergeCollectionFromExcel');
            urlParams.delete('collectionUId');
            urlParams.delete('data');
            urlParams.delete('parameters');
            urlParams.delete('isEditMode');
            urlParams.delete('redirectUrl');

            urlParams.delete('isGoogleDriveFromExcel');
            urlParams.delete('isNativeVisualizer');

            navigate(`${location.pathname}?${urlParams.toString()}`, { replace: true });
        }
    }

    useEffect(() => {
        if (queryState != null) {
            getCollectionDetails();
        }
    }, [queryState])

    const getColumnSchema = async (prevCollection, callback = null) => {
        setIsCloudLoading(true);
        let dataCollectionModal;
        if (prevCollection) {
            dataCollectionModal = getDataCollectionModal(prevCollection);
        }
        else {
            dataCollectionModal = getDataCollectionModal(null);
        }

        if (queryState?.CollectionUId && state?.templateCollectionId) {
            delete dataCollectionModal.collectionParameters;
        }
        else {
            delete dataCollectionModal.collectionColumns;
        }

        if(!dataCollectionModal.uId && !dataCollectionModal.connectionUId){
            return;
        }

        const response = await collectionService.getColumnSchema(dataCollectionModal);

        if (response) {
            if (response?.hasError) {
                setState((prevState) => { return { ...prevState, columnSchemaError: response?.errorMessage, columnSchemaList: [] } });
                setIsCloudLoading(false);

                setState((prevState) => { return { ...prevState, cloudCollectionError: response } });

                if (response?.errorMessage  == "Unauthorized") {
                    toast.error("Your connection has been expired. Please establish the connection again");
                }
                else {
                    toast.error(response?.errorMessage);
                }
            }
            else {
                setState((prevState) => { return { ...prevState, collectionColumnSchema: response?.data?.data } });

                if (callback != null) {
                    callback(response?.data?.data);
                }
                setIsCloudLoading(false);
            }
        }
    }


    const getDataCollectionModal = (prevCollection) => {
        let dataCollectionModal = new DataCollectionModal();
        let collection;
        if (prevCollection)
            collection = prevCollection;
        else
            collection = state;

        dataCollectionModal.connectionUId = collectionTypeTemplate ? selectedConnection?.uId : collection.connectionUId;
        dataCollectionModal.groupName = collection.groupName;
        dataCollectionModal.childGroupName = collection.childGroupName;
        dataCollectionModal.name = collection.name;
        dataCollectionModal.sysCollectionTypeId = collection.sysCollectionTypeId;
        dataCollectionModal.sysConnectionTypeId = collection.sysConnectionTypeId;
        dataCollectionModal.sysCollectionSubTypeId = collection.sysCollectionSubTypeId;
        dataCollectionModal.sourceName = collection.sourceName;
        dataCollectionModal.sourceNamePart2 = collection.sourceNamePart2;
        dataCollectionModal.sourceNamePart4 = collection.sourceNamePart4;
        dataCollectionModal.categoryUId = collection.categoryUId;
        dataCollectionModal.columnSchema = collection.columnSchema;
        dataCollectionModal.isCollectionAsDataSource = collection.isCollectionAsDataSource;
        dataCollectionModal.hasPrintableCollection = collection.hasPrintableCollection;
        dataCollectionModal.collectionParameters = collection.collectionParameters;
        dataCollectionModal.collectionFilterColumns = collection.collectionFilterColumns;
        dataCollectionModal.collectionColumns = collection.collectionColumns;
        dataCollectionModal.uId = collection.uId;
        dataCollectionModal.childTemplateInheritedCollectionId = collection?.childTemplateInheritedCollectionId;
        dataCollectionModal.restRequestMethod = collection.restRequestMethod ? collection.restRequestMethod : state.restRequestMethod;
        dataCollectionModal.restBody = collection.restBody ? collection.restBody : state.restBody;
        dataCollectionModal.restSendAsCD = collection.restSendAsCD ? collection.restSendAsCD : state.restSendAsCD;
        dataCollectionModal.restDataTransformationScript = collection.restDataTransformationScript ? collection.restDataTransformationScript : state.restDataTransformationScript;
        dataCollectionModal.templateCollectionId = collection?.templateCollectionId;
        dataCollectionModal.sourceNamePart2 = collection.sourceNamePart2;
        dataCollectionModal.isFilterSupported = collection?.isFilterSupported;
        dataCollectionModal.isSortSupported = collection?.isSortSupported;
        dataCollectionModal.isPagingSupported = collection?.isPagingSupported;
        dataCollectionModal.areAllFieldsFilterable = collection?.areAllFieldsFilterable;
        dataCollectionModal.areAllFieldsSortable = collection?.areAllFieldsSortable;
        dataCollectionModal.columnApiEndpoint = collection?.columnApiEndpoint;
        dataCollectionModal.variableId = collection?.variableId;
        dataCollectionModal.returnRawData = collection.returnRawData;
        dataCollectionModal.useTemplateConnection = collection?.useTemplateConnection;
        dataCollectionModal.dataStylingScript = collection.dataStylingScript;
        dataCollectionModal.dataStylingScriptId = collection.dataStylingScriptId;
        dataCollectionModal.dataTransformationScriptId = collection.dataTransformationScriptId;
        dataCollectionModal.flattenLikeSql = collection?.flattenLikeSql || false;
        dataCollectionModal.excludedProperties = collection?.excludedProperties || "";

        return dataCollectionModal;
    }

    //may be removed
    const resetErrorMessages = () => {
        setState((prevState) => {
            return {
                ...prevState, basicInfoError: null
                , columnSchemaError: null, testCollectionError: null
            }
        })
    }

    const getCurrentConnectionDetails = (connectionUId) => {
        connectionService.getDataSourceByUID(connectionUId).then((res) => {
            if (res?.data) {
                setSelectedConnection(res.data);
            }
        });
    }

    const getCollectionTypeList = (sysConnectionTypeId) => {

        collectionService.getCollectionTypeList(sysConnectionTypeId)
            .then((response) => {
                if (response?.data)
                    setState((prevState) => { return { ...prevState, collectionTypeList: response.data } });
            })
    }

    //NTD
    const addNewDataCollection = async () => {
        let dataCollectionModal = getDataCollectionModal();

        if (dataCollectionModal?.templateCollectionId) {
            setIsCloudLoading(true);
            const allColumns = state?.collectionColumnSchema?.filter(i => i.isSelected);
            const columns = allColumns.map((i) => {
                const currentColl = dataCollectionModal.collectionColumns.filter(c => c.columnName == i.columnName);
                if (currentColl.length > 0 && !collectionTypeTemplate) {
                    return {
                        collectionId: currentColl[0].collectionId,
                        columnName: currentColl[0].columnName,
                        dataType: currentColl[0].dataType,
                        dataTypeName: currentColl[0].dataTypeName,
                        displayFormat: currentColl[0].displayFormat,
                        displayName: currentColl[0].displayName,
                        id: currentColl[0].id,
                        isDefault: currentColl[0].isDefault,
                        isSortable: currentColl[0].isSortable,
                        isFilterable: currentColl[0].isFilterable,
                        notQuerable: currentColl[0].notQuerable,
                        uId: currentColl[0].uId,
                        displayOrder: i.displayOrder ?? 0,
                    }
                }
                else {
                    const matchingFormat = findDisplayFormat(i.dataTypeName, state);
                    return {
                        ...i,
                        displayOrder: i.displayOrder ?? 0,
                        displayFormat: isNullOrEmpty(i.displayFormat) ? (matchingFormat?.displayFormat ?? AppEnum.DefaultDisplayFormat.General) : i.displayFormat,
                        dataType: matchingFormat?.sysDataTypeId ?? 6
                    };
                }
            })

            dataCollectionModal.collectionColumns = columns;
            dataCollectionModal.savedParameterValue = handleSavingCloudParams();
            dataCollectionModal.restDataTransformationScript = state?.cloudDataTransformationScript;
        }

        if(collectionTypeTemplate){
            const reservedParams = [ AppEnum.ReservedKeywords.filter, AppEnum.ReservedKeywords.sort, AppEnum.ReservedKeywords.limit];
        
            dataCollectionModal.collectionParameters = dataCollectionModal.collectionParameters.filter(
                item => reservedParams.includes(item?.parameterName)
            );
        }

        dataCollectionModal.deleteExistingColumns = true;
        if ((queryState.CollectionUId && !state?.isTemplateCollection) || (queryState.CollectionUId && selectedConnection?.templateConnectionId)) {
            dataCollectionModal.uId = queryState.CollectionUId;
            await updateDataCollection(dataCollectionModal);
        }
    };   

    const getDisplayFormatList = () => {

        collectionService.getDisplayFormats()
            .then((response) => {

                if (response?.hasError)
                    setState((prevState) => { return { ...prevState, columnSchemaError: response.errorMessage } });

                else if (response?.data) {
                    setState((prevState) => { return { ...prevState, displayFormatList: response?.data } });
                }
            })
    }

    const updateDataCollection = async (dataCollectionModal) => {

        if (isNullOrEmpty(dataCollectionModal.uId) && state?.templateConnectionId) {
            dataCollectionModal.uId = queryState.CollectionUId;
        }

       await collectionService.updateDataCollection(dataCollectionModal)
            .then((response) => {
                setIsCloudLoading(false);
                if (response?.hasError) {
                    toast.error(response?.errorMessage);
                }
                else {
                    resetErrorMessages();
                    toast.success("Collection updated successfully.");
                    if(showDataVisualizer){
                        setShowDataVisualizer(false);
                    }
                    if (queryState?.isForDataCollections) {
                        navigate('/data-collections');
                    }
                    else {
                        window.chrome?.webview?.postMessage('close_window');
                    }
                }

            })
    }

    const getCollectionObjectByType = async(collectionType = AppEnum.CollectionType.FromScratch) =>{
        try {
            let connectionTypeName = selectedConnection?.connectionTypeName?.toLocaleLowerCase();
            const response = await collectionService.getCollectionObjectByType(connectionTypeName, collectionType);
            if(response?.hasError){
                toast.error(response?.errorMessage);
            }
            else {
                if(collectionType === AppEnum.CollectionType.FromScratch){
                    setState((prevState) => { return { ...prevState, cloudCollectionObjects: response?.data } });
                }
                else{
                    setState((prevState) => { return { ...prevState, childTemplateCollectionObjects: response?.data } });
                }                
            }           
        } catch (error) {
            toast.error(error);
        }
    }
    
    const windowRef = useRef();   
    const [openConnectionPopup, setOpenConnectionPopup] = useState(false);
    const [stateConnectionParameter, setStateConnectionParameter] = useState(false);
    const [isAuthorizeAgain, setIsAuthorizeAgain] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            if (openConnectionPopup) {
                getToken(selectedConnection, stateConnectionParameter, windowRef, setState,
                    openConnectionPopup, setOpenConnectionPopup, setIsAuthorizeAgain, null);
            }
        }, 3000);
        return () => clearInterval(interval);
    }, [openConnectionPopup])

    const handleAuthorizeAgain = async() =>{
        authorizeAgain(setState, selectedConnection, windowRef, setOpenConnectionPopup, setStateConnectionParameter);
    }

    const handleSavingCloudParams = () => {
        let paramsToSave = searchOptionsParameters?.filter(i => i.enableSavingParameterValue);
        if (paramsToSave?.length > 0) {
            const result = paramsToSave.map(param => ({
                Id: param.id,
                Value: param.parameterValue,
            }));
            return JSON.stringify(result);
        }
    }

    return (
        <ColumnSelectionController
            columnOverriden={columnOverriden}
            setColumnOverriden={setColumnOverriden}
            maunalColumns={maunalColumns}
            setShowDataVisualizer={setShowDataVisualizer}
            showDataVisualizer={showDataVisualizer}
            getColumnSchema={getColumnSchema}
            resetErrorMessages={resetErrorMessages}
            state={state}
            setState={setState}
            prevStepRef={null}
            setSelectedConnection={setSelectedConnection}//will check if we want to show BasicInformationController
            selectedConnection={selectedConnection}
            saveCollection={addNewDataCollection}
            isBasicInfoSubmitted={true}
            setActiveStep={null}//
            activeStep={null}//
            isUpdatingCollection={isNullOrEmpty(queryState?.CollectionUId) ? false : true}
            isLoading={isCloudLoading}
            setIsLoading={setIsCloudLoading}
            getCollectionObjectByType={getCollectionObjectByType}
            prevCloudFilterationData={prevCloudFilterationData}
            isCloudFilterationData={isCloudFilterationData}
            setIsCloudFilterationData={setIsCloudFilterationData}
            queryState={queryState}
            handleAuthorizeAgain={handleAuthorizeAgain}
            isAuthorizeAgain={isAuthorizeAgain}
            isOpenInDialog={queryState?.isForDataCollections ? true : false}
            setSearchOptionsParameters={setSearchOptionsParameters}
            isSearchOptionsAvailable={isSearchOptionsAvailable}
            searchOptionsParameters={searchOptionsParameters}
            setIsSearchOptionsAvailable={setIsSearchOptionsAvailable}
            excelDataState={pluginParameterState}
            setExcelDataState={setPluginParameterState}
            prevCloudTransformationScripts={prevCloudTransformationScripts}
            setCollectionType={setCollectionType}
            getCollectionDetails={getCollectionDetails}
            collectionTypeTemplate={collectionTypeTemplate}
            previousChildCompanyUID={previousChildCompanyUID}
        />
    )
}
